import { Button } from 'baseui/button';
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from 'baseui/modal';
import { useState } from 'react';
import AddEntryForm from './AddEntryForm';
import { useIntl, FormattedMessage } from 'react-intl';
import { addHours, startOfDay } from 'date-fns';
import { TValueOption } from '../components/ValueCellSelector';

export interface IAddEventState {
    timeFrom: Date,
    timeTo: Date,
    days: boolean[]
    value: any
}


const AddEntryDialog = (props: {
    isOpen: boolean,
    setIsOpen: any,
    onAdd: (args: IAddEventState) => void,
    dataType: string,
    showDays: boolean,
    valueOptions: TValueOption[] | undefined
}) => {

    const [state, setState] = useState<IAddEventState>({ timeFrom:  addHours(startOfDay(new Date()),8), timeTo: addHours(startOfDay(new Date()),18), days: [true, true, true, true, true, false, false], value: getDefaultValue(props.dataType) });

    return (
        <>
            <Modal closeable onClose={() => props.setIsOpen(false)} isOpen={props.isOpen}>
                <ModalHeader> <FormattedMessage id="Scheduler.AddEvent" defaultMessage="Add a new Event" /></ModalHeader>
                <ModalBody>
                    <AddEntryForm valueOptions={props.valueOptions} showDays={props.showDays} dataType={props.dataType} state={state} setState={setState}></AddEntryForm>
                </ModalBody>
                <ModalFooter>
                    <ModalButton  kind="tertiary" onClick={() => { props.setIsOpen(false); }}>
                        <FormattedMessage id="cancel" defaultMessage="Cancel" />
                    </ModalButton>
                    <ModalButton onClick={() => { props.onAdd(state); props.setIsOpen(false) }}><FormattedMessage id="add" defaultMessage="Add" /></ModalButton>
                </ModalFooter>
            </Modal>
        </>
    );
}


function getDefaultValue(dataType: string) {
    if (dataType === 'System.Boolean')
        return true;

    return 1;
}

export default  AddEntryDialog;



